import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import AdminMenu from "../../AdminMenu";
import { getTimeSlot } from "../../../services/TimeSlot/TimeSlot";

const TimeSlotList = () => {
  const navigate = useNavigate();
  const [timeSlotData, setTimeSlotData] = useState({});
  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  const [loading, setLoading] = useState(false);

  const fetchTimeSlot = (data) => {
    setLoading(true);
    getTimeSlot(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setTimeSlotData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  useEffect(() => {
    fetchTimeSlot(brandId);
  }, []);

  const slotColors = ["#E0F7FA", "#FFF3E0", "#F3E5F5", "#E8F5E9"];

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div key={index}>
          <div className="px-3 py-1 flex justify-content-between">
            <p className="text-lg font-normal text-black-700 mt-3">Time Slot {item.storeId !== null ? " for" + item.code.replace(/_/g, ' ') : ''}</p>

            <div
              className="mr-4 mt-2"
              onClick={() =>
                navigate("/TimeSlotCreate", {
                  state: {
                    item: item,
                  },
                })
              }
            >
              <i
                className="pi pi-pencil"
                style={{
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#2B70D7",
                }}
              ></i>
            </div>
          </div>
          <div className="flex-1">
            {item.slots?.length > 0 ? (
              <div className="grid grid-cols-1 gap-4 mx-4 my-3">
                {item.slots.map((itemSlot, slotIndex) => (
                  <div
                    key={slotIndex}
                    className="rounded-md p-3 shadow"
                    style={{
                      backgroundColor:
                        slotColors[slotIndex % slotColors.length],
                    }}
                  >
                    <p className="text-base font-semibold capitalize text-gray-800">
                      {itemSlot.value}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="px-3 py-2 text-gray-500 italic">
                No slots available
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Time Slot Management
              </p>
            </div>
          </div>

          {timeSlotData?.length === 0 && (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() =>
                navigate("/TimeSlotCreate", {
                  state: {
                    item: null,
                  },
                })
              }
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : timeSlotData?.length > 0 ? (
          <div>
            <div>{renderCardItem(timeSlotData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Time Slot Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default TimeSlotList;
